<template>
    <transition name="modal" v-if="isActive">
        <div class="modal-mask" @click="hide()">
            <div class="modal-language modal-dialog" role="document">
                <div class="modal-content">
                    <div class="box" @click.stop>
                        <h2>Language</h2>
                        <button @click="selectLang('th')">
                            <img src="@/assets/flag-th.png" alt="ProbPlus - ภาษาไทย" title="ProbPlus - ภาษาไทย" />
                            <span>ภาษาไทย</span>
                        </button>
                        <button @click="selectLang('en')">
                            <img src="@/assets/flag-en.png" alt="ProbPlus - English" title="ProbPlus - English" />
                            <span>English</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import PPlusModal from '@/resources/PPlusModal.js';

export default {
    data() {
        return {
            isActive: false
        }
    },
    methods: {
        show() {
            this.isActive = true;
        },
        hide() {
            this.isActive = false;
        },
        selectLang(langCode) {
            this.hide();
            this.$WeHelper.modalLoad();
            this.$cookie.set('defaultLang', langCode, { expires: '1Y' });

            let website = location.origin;
            let pathname = location.pathname;

            pathname = pathname.substring(3);

            location.href = website + '/' + langCode + pathname;
        }
    },
    beforeMount() {
        PPlusModal.EventBus.$on('showLanguage', () => {
            this.show();
        });
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.modal-language {
    width: 100%;
    max-width: 270px;
    margin-left: auto;
    margin-right: auto;

    .box {
        background: #fff;
        width: 100%;
        margin: auto;

        h2 {
            font-weight: bold;
            font-size: 15px;
            margin: 0;
            padding: 15px 10px;
            text-align: center;
            background: #eee;
            border-bottom: 1px solid #bbb;
        }

        button {
            position: relative;
            width: 100%;
            height: 60px;
            border: none;
            border-bottom: 1px solid #ddd;
            background: none;
            outline: none;
            @include transition(none);

            &:last-child {
                border-bottom: none;
            }

            &:hover {
                background: #ccc;
            }

            img {
                position: absolute;
                display: block;
                left: 15px;
                width: 30px;
            }

            span {
                display: block;
                font-size: 14px;
            }
        }
    }
}
</style>